import { render, staticRenderFns } from "./SeedingOtherDetails.vue?vue&type=template&id=18e46f51&scoped=true&"
import script from "./SeedingOtherDetails.vue?vue&type=script&lang=js&"
export * from "./SeedingOtherDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e46f51",
  null
  
)

export default component.exports